<template>
  <div>
    <div @click="riseup" class="btn btn-success btn-circle top text-center">上升</div>
    <div class="hidden-xs">
      <img src="../../common/images/banner.jpg" class="img-responsive center-block" height="420" />
    </div>
    <div class="row">
      <div class="col-xs-6 col-md-3">
        <router-link :to="{path:'/BU',query: {index: 0}}" class="thumbnail">
          <img src="../../common/images/BU01.jpg" alt="暂无" />
          <div class="caption">
            <h3 class="text-center">BU01</h3>
          </div>
        </router-link>
      </div>
      <div class="col-xs-6 col-md-3">
        <router-link :to="{path:'/BU/01KB',query: {index: 1}}" class="thumbnail">
          <img src="../../common/images/BU01KB.jpg" alt="暂无" />
          <div class="caption">
            <h3 class="text-center">BU01KB</h3>
          </div>
        </router-link>
      </div>
      <div class="col-xs-6 col-md-3">
        <router-link :to="{path:'/BU/01PB',query: {index: 2}}" class="thumbnail">
          <img src="../../common/images/BU01PB.jpg" alt="暂无" />
          <div class="caption">
            <h3 class="text-center">BU01PB</h3>
          </div>
        </router-link>
      </div>
      <div class="col-xs-6 col-md-3">
        <router-link :to="{path:'/SMQ/02',query: {index: 0}}" class="thumbnail">
          <img src="../../common/images/BU02.jpg" alt="暂无" />
          <div class="caption">
            <h3 class="text-center">BU02</h3>
          </div>
        </router-link>
      </div>
      <div class="col-xs-6 col-md-3">
        <router-link :to="{path:'/SMQ/02PB',query: {index: 1}}" class="thumbnail">
          <img src="../../common/images/BU02PB.jpg" alt="暂无" />
          <div class="caption">
            <h3 class="text-center">BU02PB</h3>
          </div>
        </router-link>
      </div>
      <div class="col-xs-6 col-md-3">
        <router-link :to="{path:'/BH/04',query: {index: 0}}" class="thumbnail">
          <img src="../../common/images/BH04.jpg" alt="暂无" />
          <div class="caption">
            <h3 class="text-center">BH04</h3>
          </div>
        </router-link>
      </div>
      <div class="col-xs-6 col-md-3">
        <router-link :to="{path:'/BH/04KB',query: {index: 1}}" class="thumbnail">
          <img src="../../common/images/BH04KB.jpg" alt="暂无" />
          <div class="caption">
            <h3 class="text-center">BH04KB</h3>
          </div>
        </router-link>
      </div>
      <div class="col-xs-6 col-md-3">
        <router-link :to="{path:'/RU/02',query: {index: 0}}" class="thumbnail">
          <img src="../../common/images/RU02.jpg" alt="暂无" />
          <div class="caption">
            <h3 class="text-center">RU02</h3>
          </div>
        </router-link>
      </div>
      <div class="col-xs-6 col-md-3">
        <router-link :to="{path:'/RU/03',query: {index: 1}}" class="thumbnail">
          <img src="../../common/images/RU03.jpg" alt="暂无" />
          <div class="caption">
            <h3 class="text-center">RU03</h3>
          </div>
        </router-link>
      </div>
      <div class="col-xs-6 col-md-3">
        <router-link :to="{path:'/BU04/PB',query: {index: 1}}" class="thumbnail">
          <img src="../../common/images/BU04PB.jpg" alt="暂无" />
          <div class="caption">
            <h3 class="text-center">BU04PB</h3>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { riseup } from "@/common/js/riseup.js";
export default {
  data() {
    return {};
  },
  methods: {
    riseup() {
      riseup()
    }
  },
  components: {}
};
</script>

<style lang="stylus" scoped rel="stylesheet/stylus">
.row {
  margin-top: 20px;

  .thumbnail {
    border: 4px solid #d5d5d5;
    border-radius: 8px;
    box-sizing: border-box;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.8);
    overflow: hidden;

    &:hover {
      box-shadow: 0 0 20px rgba(0, 0, 0, 0.8);
      transform: scale(1.1);
    }

    img {
      height: 180px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/homeindex.vue